import React, { useState } from "react";
import { Container, Row, Col, Form, Card } from "react-bootstrap";
import { FaIdCard, FaShieldAlt, FaLock } from "react-icons/fa";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { createocrVerification } from "../../utils/helpers/fileupload";
import '../../App.css';
import { useDispatch } from "react-redux";
import { getProfile } from "../../store/slices/profile";



export default function VerifyAadhaar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [aadhaarFront, setAadhaarFront] = useState(null);
  const [aadhaarBack, setAadhaarBack] = useState(null);
  const MAX_FILE_SIZE = 4 * 1024 * 1024; // 3 MB
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!aadhaarFront) {
      toast.error("Please upload Aadhaar front image.");
      return;
    }

    setLoading(true);

    try {
      const token = localStorage.getItem("accessToken");

      const result = await createocrVerification(
        aadhaarFront,
        aadhaarBack,
        token
      );

      toast.success(result.message || "Aadhaar verified successfully.");

      console.log("Navigation starting...");
      await dispatch(getProfile());
      setTimeout(() => {
        console.log("Navigating...");
        navigate("/user/home");
      }, 1500);
    } catch (err) {
      toast.error(err || "Unable to verify Aadhaar.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col lg={6} md={8}>
          <Card className="shadow-lg border-0 verify-card">
            <Card.Body className="p-5">

              <div className="text-center mb-4">
                <div className="verify-icon">
                  <FaIdCard />
                </div>

                <h2 className="verify-title">
                  Verify Your Aadhaar
                </h2>

                <p className="verify-subtitle">
                  Aadhaar verification helps us maintain genuine profiles and
                  improves trust across our matrimony community.
                </p>
              </div>

              <Form onSubmit={handleSubmit}>

                <Form.Group className="mb-4">
                  <Form.Label>
                    Aadhaar Front <span className="text-danger">*</span>
                  </Form.Label>

                  <Form.Control
                    type="file"
                    accept="image/png,image/jpeg,image/jpg"
                    onChange={(e) => {
                      const file = e.target.files[0];

                      if (!file) return;

                      if (file.size > MAX_FILE_SIZE) {
                        toast.error("Aadhaar Front image must be less than 3 MB.");
                        e.target.value = "";
                        setAadhaarFront(null);
                        return;
                      }

                      setAadhaarFront(file);
                    }}
                    required
                  />

                  <small className="text-muted">
                    Upload a clear image of the front side of your Aadhaar card.
                  </small>
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label>
                    Aadhaar Back
                  </Form.Label>

                  <Form.Control
                    type="file"
                    accept="image/png,image/jpeg,image/jpg"
                    onChange={(e) => {
                      const file = e.target.files[0];

                      if (!file) return;

                      if (file.size > MAX_FILE_SIZE) {
                        toast.error("Aadhaar Back image must be less than 3 MB.");
                        e.target.value = "";
                        setAadhaarBack(null);
                        return;
                      }

                      setAadhaarBack(file);
                    }}
                  />

                  <small className="text-muted">
                    Optional. Upload the back side if the QR code is present there.
                  </small>
                </Form.Group>

                <button
                  style={{
                    marginTop: "20px",
                    width: "100%",
                    padding: "12px",
                    background: "#7b1e3b",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "600"
                  }}
                  type="submit"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                      Verifying...
                    </>
                  ) : (
                    "Verify Aadhaar"
                  )}
                </button>

              </Form>

              <div className="verify-info mt-5">

                <div className="verify-item">
                  <FaShieldAlt className="verify-item-icon" />

                  <div>
                    <h6>Government Verified</h6>

                    <p>
                      Verification is securely completed through DigiLocker.
                    </p>
                  </div>
                </div>

                <div className="verify-item">
                  <FaLock className="verify-item-icon" />

                  <div>
                    <h6>Privacy Protected</h6>

                    <p>
                      We never store your full Aadhaar number.
                    </p>
                  </div>
                </div>

              </div>

            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}